
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/ts/dist/ts/src/components/search/subsectionSearch.47e330515f4c.js";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/ts/dist/ts/src/components/search/subsectionSearch.47e330515f4c.js";